import React, { useState } from "react";
import "../../CSS/userListItem.css";
import Avatar from "@mui/material/Avatar";
import Spinner from "react-bootstrap/Spinner";

const UserListItem = (props) => {
  // console.log("props", props);
  // const [user, setUser] = useState(props.user);
  const [avatarLoading, setAvatarLoading] = useState(true);
  setTimeout(() => {
    setAvatarLoading(false);
  }, 200);

  const userHandler = () => {
    if (props.userHandler) {
      props.userHandler();
    }
  };
  return (
    <>
      <div className="user_list" onClick={userHandler}>
        <Avatar
          src={props.user.pic}
          name={props.user.name}
          style={{
            margin: "5px",
            marginRight: "10px",
            borderRadius: "100%",
            position: avatarLoading ? "absolute" : "",
          }}
        />
        {avatarLoading ? (
          <div
            style={{
              fontSize: "10px",
              marginRight: "20px",
              marginLeft: "15px",
            }}
          >
            <Spinner
              animation="border"
              variant="secondary"
              style={{ width: "20px", height: "20px" }}
            />
          </div>
        ) : null}

        <div>
          <span className="userName">{props.user.name}</span>
          <h6>
            {/* <b>Email:</b> */}
            {props.user.email}
          </h6>
        </div>
      </div>
    </>
  );
};

export default UserListItem;
